/*
 * Add to cart labels and the option gate on the product page.
 *
 * Every non-color option (Size, Model, ...) is pre-checked internally but shown as "not chosen"
 * until the customer taps a value in EACH of them; Add to cart is blocked until then (main
 * button, sticky bar, dynamic checkout).
 *
 * Labels:
 *   main button   not chosen: "Choose a size"      chosen: "Add to cart · $48"
 *   sticky bar    not chosen: "Select Size"        chosen: "M  ·  $48  ·  Add to cart"
 *                 (phone models are left out; with only a model option it shows the color)
 * Products with no size / model (color only) show the clean sticky bar right away: "Black  ·  $48
 * ·  Add to cart" with no name or price on the left (body class ja-sticky-clean).
 * A blocked tap scrolls up so ALL the options are in view. Picking a size / model does not move
 * the photo gallery or the page. The mobile photo gallery gets dots.
 */
(function () {
  if (window.__sizeGateLoaded) return;
  window.__sizeGateLoaded = true;

  var required = [];
  var chosen = {};
  var inited = false;
  var SEP = '  ·  ';

  function mainInfo() { return document.querySelector('product-info[id^="MainProduct"]'); }
  function fieldsets() {
    var info = mainInfo();
    return info ? Array.prototype.slice.call(info.querySelectorAll('fieldset[data-size-option]')) : [];
  }
  function fsName(fs) { return fs.getAttribute('data-size-option') || ''; }
  function missing() { return required.filter(function (n) { return !chosen[n]; }); }
  function isActive() { return missing().length > 0; }
  function titleCase(s) { return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
  function mainButton() { return document.querySelector('[id^="ProductSubmitButton-"]'); }
  function stickyButton() { return document.querySelector('.sticky-atc__button'); }

  function priceText() {
    var btn = mainButton();
    if (!btn) return '';
    var p = document.getElementById('price-' + btn.id.replace('ProductSubmitButton-', ''));
    if (!p) return '';
    var onSale = !!p.querySelector('.price--on-sale') || p.classList.contains('price--on-sale');
    var el = onSale ? p.querySelector('.price__sale .price-item--sale') : p.querySelector('.price__regular .price-item--regular');
    if (!el) return '';
    return el.textContent.replace(/\s+/g, ' ').trim().replace(/\s+[A-Z]{3}$/, '');
  }

  function chosenValues() {
    var out = [];
    fieldsets().forEach(function (fs) {
      if (/model|device|phone/i.test(fsName(fs))) return;
      var input = fs.querySelector('input:checked');
      if (input && input.value) out.push(input.value);
    });
    if (!out.length) {
      var info = mainInfo();
      var c = info ? info.querySelectorAll('fieldset input[type="radio"]:checked') : [];
      for (var i = 0; i < c.length; i++) {
        if (!c[i].closest('fieldset[data-size-option]') && c[i].value) { out.push(c[i].value); break; }
      }
    }
    return out.join(' / ');
  }

  function defaultAddText() {
    return ((window.variantStrings && window.variantStrings.addToCart) || 'Add to cart').trim();
  }

  function norm(s) { return s.replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }

  function setLabel(btn, text) {
    if (!btn) return;
    var el = btn.querySelector('span') || btn;
    var current = el.textContent.trim();
    var ours = btn.dataset.sizeGateLabel;
    var isDefault = norm(current).toLowerCase() === norm(defaultAddText()).toLowerCase();
    if (!(isDefault || (ours && current === ours))) return;
    if (current !== text) el.textContent = text;
    btn.dataset.sizeGateLabel = text;
  }

  function relabel() {
    var price = priceText();
    var add = defaultAddText();
    var main = mainButton();
    var sticky = stickyButton();
    if (isActive()) {
      var first = missing()[0];
      setLabel(main, 'Choose a ' + first.toLowerCase());
      setLabel(sticky, 'Select ' + titleCase(first));
    } else {
      setLabel(main, price ? add + ' · ' + price : add);
      var parts = [];
      var values = chosenValues();
      if (values) parts.push(values);
      if (price) parts.push(price);
      parts.push(add);
      setLabel(sticky, parts.join(SEP));
    }
  }

  function markFieldsets() {
    fieldsets().forEach(function (fs) {
      var n = fsName(fs);
      if (chosen[n]) {
        fs.classList.add('size-gate-done');
        fs.classList.remove('size-gate-unchosen');
      } else if (required.indexOf(n) > -1) {
        fs.classList.add('size-gate-unchosen');
      }
    });
  }

  function restoreScroll() {
    var k = window.__jaKeep;
    if (k && Date.now() - k.t < 1800 && Math.abs(window.scrollY - k.y) > 3) {
      window.scrollTo({ top: k.y, behavior: 'instant' });
    }
  }

  function update() {
    document.body.classList.toggle('size-gate-active', isActive());
    document.body.classList.toggle('ja-sticky-clean', !isActive());
    markFieldsets();
    relabel();
    if (!isActive()) hideMessage();
    restoreScroll();
  }

  function firstMissingFieldset() {
    var m = missing()[0];
    var found = null;
    fieldsets().forEach(function (fs) { if (!found && fsName(fs) === m) found = fs; });
    return found;
  }

  function scrollToPicker(fs) {
    var top = fs.closest('variant-selects') || fs.closest('fieldset') || fs;
    var first = top.querySelector('fieldset, .product-form__input');
    var target = first && top.contains(first) ? first : top;
    var y = target.getBoundingClientRect().top + window.scrollY - 110;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function showMessage() {
    var fs = firstMissingFieldset();
    if (!fs) return;
    var msg = document.querySelector('.size-gate__message');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'size-gate__message';
      msg.setAttribute('role', 'alert');
    }
    msg.textContent = 'Please select a ' + missing()[0].toLowerCase();
    fs.insertAdjacentElement('afterend', msg);
    fs.classList.add('size-gate__attention');
    setTimeout(function () { fs.classList.remove('size-gate__attention'); }, 1200);
    scrollToPicker(fs);
  }
  function hideMessage() {
    var msg = document.querySelector('.size-gate__message');
    if (msg) msg.remove();
  }

  function noJumpActive() { return Date.now() - (window.__jaNoJump || 0) < 4000; }
  function patchGallery() {
    customElements.whenDefined('media-gallery').then(function () {
      var C = customElements.get('media-gallery');
      if (C && !C.prototype.__jaPatched && typeof C.prototype.setActiveMedia === 'function') {
        var orig = C.prototype.setActiveMedia;
        C.prototype.setActiveMedia = function () {
          if (noJumpActive()) return;
          return orig.apply(this, arguments);
        };
        C.prototype.__jaPatched = true;
      }
    });
    var tries = 0;
    (function patchSwiper() {
      var S = window.Swiper;
      if (S && S.prototype && typeof S.prototype.slideTo === 'function') {
        if (!S.prototype.__jaPatched) {
          var st = S.prototype.slideTo;
          S.prototype.slideTo = function () {
            if (noJumpActive()) return this;
            return st.apply(this, arguments);
          };
          S.prototype.__jaPatched = true;
        }
      } else if (tries++ < 20) {
        setTimeout(patchSwiper, 500);
      }
    })();
  }

  function buildDots() {
    var ul = document.querySelector('[id^="Slider-Gallery-"]');
    if (!ul) return;
    var items = ul.querySelectorAll('li.product__media-item');
    var old = document.querySelector('.ja-dots');
    if (items.length < 2) { if (old) old.remove(); return; }
    if (old && old.children.length === items.length) return;
    if (old) old.remove();
    var dots = document.createElement('div');
    dots.className = 'ja-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < items.length; i++) {
      (function (idx) {
        var d = document.createElement('span');
        d.className = 'ja-dot';
        d.addEventListener('click', function () {
          var li = ul.querySelectorAll('li.product__media-item')[idx];
          if (li) ul.scrollTo({ left: li.offsetLeft - ul.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(d);
      })(i);
    }
    ul.parentNode.insertBefore(dots, ul.nextSibling);
    if (!ul.__jaDots) {
      ul.__jaDots = true;
      ul.addEventListener('scroll', markDots, { passive: true });
    }
    markDots();
  }
  function markDots() {
    var ul = document.querySelector('[id^="Slider-Gallery-"]');
    var dots = document.querySelector('.ja-dots');
    if (!ul || !dots) return;
    var items = ul.querySelectorAll('li.product__media-item');
    var best = 0, bestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var dist = Math.abs(items[i].offsetLeft - ul.offsetLeft - ul.scrollLeft);
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    for (var j = 0; j < dots.children.length; j++) {
      dots.children[j].classList.toggle('is-active', j === best);
    }
  }

  function init() {
    if (inited) return;
    if (!mainInfo() || !mainButton()) return;
    inited = true;
    required = [];
    fieldsets().forEach(function (fs) {
      if (fs.hasAttribute('data-size-unchosen') && required.indexOf(fsName(fs)) === -1) required.push(fsName(fs));
    });
    update();
    patchGallery();
    buildDots();
    setTimeout(buildDots, 800);

    document.addEventListener('click', function (e) {
      var t = e.target;
      var fs = t && t.closest ? t.closest('fieldset[data-size-option]') : null;
      if (fs) {
        window.__jaKeep = { y: window.scrollY, t: Date.now() };
        [60, 250, 600, 1200].forEach(function (ms) { setTimeout(restoreScroll, ms); });
        if (!/colou?r/i.test(fsName(fs))) window.__jaNoJump = Date.now();
        if (isActive()) {
          chosen[fsName(fs)] = true;
          update();
        }
      }
    }, true);

    document.addEventListener('submit', function (e) {
      if (!isActive()) return;
      var f = e.target;
      if (f && f.matches && f.matches('form[data-type="add-to-cart-form"]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMessage();
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (!isActive()) return;
      var w = e.target && e.target.closest && e.target.closest('.shopify-payment-button');
      if (w) {
        e.preventDefault();
        e.stopPropagation();
        showMessage();
      }
    }, true);

    var info = mainInfo();
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      Promise.resolve().then(function () { pending = false; update(); });
    }
    new MutationObserver(schedule).observe(info, { childList: true, subtree: true, characterData: true });
    var sticky = stickyButton();
    if (sticky) new MutationObserver(schedule).observe(sticky, { childList: true, characterData: true, subtree: true });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(update, 0);
        setTimeout(buildDots, 400);
        setTimeout(function () { window.__jaNoJump = 0; }, 700);
      });
    }
    setTimeout(update, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { inited = false; chosen = {}; init(); });
})();
